export const PAYMENT_METHOD_VIEW = {
  SELECT: "SELECT",
  NEW: "NEW",
}
